
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";
import { useEffect, useState } from "react";

const StickyMobileCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToForm = () => {
    document.querySelector('form')?.scrollIntoView({ behavior: 'smooth' });
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-emerald-200 p-4 md:hidden z-40 shadow-lg">
      <Button 
        onClick={scrollToForm}
        className="w-full bg-emerald-600 hover:bg-emerald-700 text-white py-3 text-lg font-semibold"
      >
        <Phone className="w-5 h-5 mr-2" />
        Get a Call Back in 10 Minutes
      </Button>
    </div>
  );
};

export default StickyMobileCTA;
